import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_INVENTORY_VIEW, GET_INVENTORY_VIEW_SUCCESS, GET_INVENTORY_VIEW_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getInventoryView({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/card-data-detailed-view`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: GET_INVENTORY_VIEW_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: GET_INVENTORY_VIEW_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_INVENTORY_VIEW_ERROR, payload: error });
  }
}

export function* watchGetInventoryView() {
  yield takeEvery(GET_INVENTORY_VIEW, getInventoryView);
}

function* getInventoryViewSaga() {
  yield all([fork(watchGetInventoryView)]);
}

export default getInventoryViewSaga;
